<div style="padding: 10px 20px 10px 20px;">
  <span>{{printNodeOrderItem.ID}} </span>
  <span>{{printNodeOrderItem.quantity}} </span>
<!--  <span>{{printNodeOrderItem.book.weight}} </span>-->
<!--  <span>{{printNodeOrderItem.book.body.width/72}}in X{{printNodeOrderItem.book.body.height/72}}in </span>-->
  <span>{{printNodeOrderItem.book.title}} </span>
</div>
